<nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-header">
        <a class="navbar-brand" href="#">
            <img src="assets/images/mu_logo.png" alt="logo" class="logo">
            <span class="seperator">|</span>
            <img src="assets/images/elogo.png" alt="logo" class="elogo">
        </a>
      </div>
      <ul class="nav navbar-nav navbar-right">
        <!-- <li><a href="http://univ.secur.co.in/University/login" class="click-btn">CLICK HERE TO CONTINUE</a></li> -->
        <li class="right-nav"><a routerLink="/verification">Home</a></li>
        <li class="right-nav"><a routerLink="/faq">FAQ</a></li>
      </ul>
    </div>
</nav>

<div class="faq-section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h1 class="faq-hd">FAQ Section</h1>
                <p class="question">Q. How long will my request take to process ?</p>
                <p class="answer">A. Requests typically take 7-10 working days to process. This may sometimes get delayed in case of holidays in the University / College, or if the record requested for is old.</p>
                <p class="question">Q. How do I know my request has been accepted ?</p>
                <p class="answer">A. Any request will only be declined if the documents you have uploaded are either incomplete, or unclear. In either of these situations, you will receive an email from us on your registered email id, stating the pending information required from your end. Once we receive the pending information, the request will get processed.</p>
                <p class="question">Q. How do I know my payment has been received ?</p>
                <p class="answer">A. As soon as your payment is received by us from our online payment gateway partner, you will receive a receipt for the same on your registered email id. The receipt can also be download from your account as well.</p>
                <p class="question">Q. How is my request going to be processed ?</p>
                <p class="answer">A. For each request, we access the University / College archives to search for the information. Once this is received, we compare it to the documents uploaded by you, and send you a report on your registered email id.</p>
                <p class="question">Q. How do I track the status of my request ?</p>
                <p class="answer">A. You can log into this website, with the same user id and password you used for registration, to get the latest update on your request.</p>
                <p class="question">Q. On the website, my request shows as “Completed”, but I have not received any report.</p>
                <p class="answer">A. Please check in your registered email, in the Spam or Junk folders in case the report has gone there. If you still don’t see the report, write to us at help@educred.co.in</p>
                <p class="question">Q. The transaction failed while I uploaded my request, but the money got debited from my account. What should I do ?</p>
                <p class="answer">A. Do not worry. We will get a report of the same at our end, and the money will get automatically refunded to your account within 7 working days. In case you do not receive it within that period, you can write to us through the Contact Us Option or submit your query through the form provided.</p>
                <p class="question">Q. Can I ask for a refund once I have placed a request ?</p>
                <p class="answer">A. Unfortunately, no. Once we receive your completed request and your corresponding payment, the request is already under process. We may only refund your payment in extremely rare circumstances, where we are unable to process the request due to some failure at our end.</p>
                <p class="question">Q. How do I know the report I receive is genuine ?</p>
                <p class="answer">A. As you will see once you receive the report, it carries the signature of the designated official from the University.</p>
                <p class="question">Q. I do not wish to follow the online process. Can I approach the University directly for my request ?</p>
                <p class="answer">A. This online process has been adopted by the University in order to make the processing of requests faster, hassle-free and transparent for students. With the adopting of the online process, these Universities / Colleges will have stopped accepting any manual request. However, if you still wish to approach the University and attempt the same, you are free to do so.</p>
                <p class="question">Q. In case of any queries / complaints / clarifications, whom should I approach ?</p>
                <p class="answer">A. ou may write to us through the Contact Us Option or submit your query through the form provided on the site and we will respond to you within 2 working days of receiving your query.</p>
            </div>
        </div>
    </div>
</div>

<div class="contact-section">
    <div class="contact-form">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <h3 class="contact-form-hd">Fill the form & we will get back.</h3>
            <form>
              <input type="text" class="form-control form-input" placeholder="Enter your Email id">
              <textarea class="form-control form-input" placeholder="Enter your Query"></textarea>
              <button class="form-btn">Submit</button>
            </form>
          </div>
          <div class="col-md-8"></div>
        </div>
      </div>
    </div>
    <div class="footer">
        <div class="d-flex-footer">
            <a href="#"><img src="assets/images/footericon1.jpg" alt="icon" class="footer-icon"></a>
            <a href="#"><img src="assets/images/footericon2.jpg" alt="icon" class="footer-icon"></a>
            <a href="#"><img src="assets/images/footericon3.jpg" alt="icon" class="footer-icon"></a>
        </div>
        <div class="d-flex-footer">
            <a href="#" class="footer-link">Home</a>
            <a href="#" class="footer-link">Process</a>
            <a href="#" class="footer-link">Terms</a>
            <a href="#" class="footer-link">Privacy Policy</a>
            <a routerLink="/refundPolicy" class="footer-link">Refund Policy</a>
            <a href="#" class="footer-link">Sitemap</a>
        </div>
    </div>
</div>